import React from "react";
import { Link } from "react-router-dom";
import Carousel from "../../Components/Carousel/Carousel";
import { IoIosArrowForward } from "react-icons/io";
import { FaArrowRight } from "react-icons/fa";
import "./Service.css";
const Services = () => {
  return (
    <div>
      <div className="bg_banner_about ">
        <h1>Product</h1>
        <div className="bread_craum">
          <Link
            to="/"
            style={{
              textDecoration: "auto",
              fontFamily: "Nunito",
              color: "#0F172B",
            }}
          >
            Home
          </Link>
          <IoIosArrowForward style={{ color: "#0F172B", marginTop: "4px" }} />
          <Link
            to="/"
            style={{
              textDecoration: "auto",
              fontFamily: "Nunito",
              color: "#0F172B",
            }}
          >
            Product
          </Link>
        </div>
      </div>

      <div class="blog-container">
    <div class="blog-item">
      <Link to="/Oilfilter">
        <div class="icon">
          <img class="img-class" src="./images/gallery10.png" alt=""/>
        </div>
        <div class="content responsive_product">
          <div class="title">Oil Filter </div>
          <div class="rounded"></div>
          <p style={{textAlign:"justify"}}>
		  At our company, we take pride in our expertise in manufacturing high-quality oil filters that play a vital role in preserving the well-being and efficiency of your vehicle's engine. Our oil filters are meticulously crafted with precision engineering and advanced filtration technology to ensure optimal performance and reliability.

Designed to eliminate impurities and pollutants from the engine oil, our oil filters provide essential protection against harmful contaminants that can cause premature wear and damage to engine components. By keeping the engine oil clean and free of debris, our filters help maintain proper lubrication and ensure smooth engine operation
          </p>
        </div>
        <div class="item-arrow">
          <i class="fa fa-long-arrow-right" aria-hidden="true"></i>
        </div>
      </Link>
    </div>

	<div class="blog-item">
      <Link to="/Deselfilter">
        <div class="icon">
          <img class="img-class" src="./images/gallery1.jpeg" alt=""/>
        </div>
        <div class="content responsive_product">
          <div class="title">Diesel Filter </div>
          <div class="rounded"></div>
          <p style={{textAlign:"justify"}}>
		  At the heart of every diesel engine lies our meticulously crafted diesel filters, designed to ensure optimal performance and reliability. These essential components play a crucial role in refining diesel fuel before it reaches the engine, effectively removing impurities and contaminants that could compromise engine efficiency.

Built with precision engineering and advanced filtration technology, our diesel filters provide unparalleled protection for diesel engines in a wide range of applications. From commercial fleets to industrial machinery, our filters deliver consistent results, maintaining peak performance and prolonging the lifespan of diesel engines.
          </p>
        </div>
        <div class="item-arrow">
          <i class="fa fa-long-arrow-right" aria-hidden="true"></i>
        </div>
      </Link>
    </div>

	<div class="blog-item">
      <Link to="/fuelstrainer">
        <div class="icon">
          <img class="img-class" src="./images/hydraulifilter.jpeg" alt=""/>
        </div>
        <div class="content responsive_product">
          <div class="title">Fuel Strainer</div>
          <div class="rounded"></div>
          <p style={{textAlign:"justify"}}>
		  Our fuel strainers are meticulously engineered to sift out foreign particles or liquids from fuel, safeguarding the vital components within the fuel system. They play a critical role in ensuring the longevity and efficiency of internal combustion engines, as they prevent contaminants from reaching sensitive engine parts. Designed with precision and durability in mind, our fuel strainers undergo rigorous testing to meet the highest standards of quality and reliability. 

By effectively filtering out impurities, our fuel strainers help prevent clogs, corrosion, and other fuel-related issues that can compromise engine performance. With advanced filtration technology, they ensure that only clean fuel flows through the system, optimizing engine operation and fuel economy.
          </p>
        </div>
        <div class="item-arrow">
          <i class="fa fa-long-arrow-right" aria-hidden="true"></i>
        </div>
      </Link>
    </div>

    <div class="blog-item">
      <Link to="/InlinepaperOilfilters">
        <div class="icon">
          <img class="img-class" src="./images/inlinepaper.jpg" alt=""/>
        </div>
        <div class="content responsive_product">
          <div class="title">Inline Paper Oil Filters</div>
          <div class="rounded"></div>
          <p style={{textAlign:"justify"}}>
          An inline paper oil filter is a crucial component in a vehicle's engine system. It is designed to remove impurities and contaminants from the oil flow, ensuring clean and lubricated engine parts. The filter uses a paper element to trap dirt and debris, preventing them from circulating through the engine. Regular replacement of the inline paper oil filter is recommended to maintain the engine's performance and longevity. It is important to follow the manufacturer's guidelines for filter replacement intervals.
          </p>
        </div>
        <div class="item-arrow">
          <i class="fa fa-long-arrow-right" aria-hidden="true"></i>
        </div>
      </Link>
    </div>


    <div class="blog-item">
      <Link to="/HydraulicFilterSystem">
        <div class="icon">
          <img class="img-class" src="./images/DeWatermark.ai_1714025046840.png" alt=""/>
        </div>
        <div class="content responsive_product">
          <div class="title">Hydraulic Filter System</div>
          <div class="rounded"></div>
          <p style={{textAlign:"justify"}}>
          A hydraulic filter system is essential for maintaining the cleanliness and efficiency of hydraulic fluids used in machinery. It removes contaminants like dirt, debris, and particles from the fluid, preventing damage to components. The system typically consists of filters, housings, and bypass valves to ensure proper filtration. Regular maintenance and replacement of hydraulic filters are necessary to prevent system failures and extend the equipment's lifespan
          </p>
        </div>
        <div class="item-arrow">
          <i class="fa fa-long-arrow-right" aria-hidden="true"></i>
        </div>
      </Link>
    </div>

  </div>

    </div>
  );
};
export default Services;
